/* Moonshot Tees — behaviour for the ms-* sections. No dependencies. */
(function () {
  "use strict";

  // Fallback swatch colours for Gildan 5000 colour names (used when Shopify swatches are not configured)
  var HEX = {
    "black": "#1d1e20", "white": "#f5f4f0", "navy": "#1f2a44", "forest green": "#2f4a3a",
    "ash": "#cfcfca", "natural": "#ebe3d0", "garnet": "#6b2232", "sport grey": "#9fa09e",
    "cardinal red": "#9b1d30", "sand": "#d8c7a6", "graphite heather": "#5b5d60", "light blue": "#a9c4dc"
  };
  var COLOR_NAMES = ["color", "colour", "farbe", "couleur", "color "];
  var SIZE_ORDER = ["XS", "S", "M", "L", "XL", "2XL", "XXL", "3XL", "4XL", "5XL"];

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  var toastTimer;
  function toast(html) {
    var t = $(".ms-toast");
    if (!t) { t = document.createElement("div"); t.className = "ms-toast"; t.setAttribute("role", "status"); document.body.appendChild(t); }
    t.innerHTML = html; t.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.hidden = true; }, 3500);
  }

  function refreshCartBubble() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    fetch(root + "?sections=cart-icon-bubble")
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var bubble = document.getElementById("cart-icon-bubble");
        if (!bubble || !data["cart-icon-bubble"]) return;
        var tmp = document.createElement("div");
        tmp.innerHTML = data["cart-icon-bubble"];
        var inner = tmp.querySelector(".shopify-section") || tmp;
        bubble.innerHTML = inner.innerHTML;
      })
      .catch(function () {});
  }

  /* ---------------- Product grid ---------------- */
  function initGrid(section) {
    var cards = $$(".ms-grid--all .ms-card", section);
    var rows = $(".ms-rows", section);
    var gridAll = $(".ms-grid--all", section);
    var pills = $$(".ms-pill", section);
    var search = $(".ms-search input", section);
    var moreBtn = $(".ms-more button", section);
    var moreTxt = $(".ms-more span", section);
    var empty = $(".ms-empty", section);
    var step = parseInt(section.dataset.step || "8", 10);
    var limit = step;
    var filter = "all";
    var cartUrl = section.dataset.cartUrl || "/cart";

    // counts on pills
    pills.forEach(function (p) {
      var h = p.dataset.handle;
      var n = h === "all" ? cards.length : cards.filter(function (c) { return (" " + c.dataset.cols + " ").indexOf(" " + h + " ") > -1; }).length;
      var s = p.querySelector("small"); if (s) s.textContent = n;
      if (h !== "all" && n === 0) p.hidden = true;
    });

    function apply() {
      var q = (search && search.value || "").trim().toLowerCase();
      var browse = filter === "all" && !q && rows && rows.children.length;
      if (rows) rows.hidden = !browse;
      if (gridAll) gridAll.hidden = !!browse;
      if (browse) { if (empty) empty.hidden = true; if (moreBtn) moreBtn.parentNode.hidden = true; return; }
      var shown = 0, matched = 0;
      cards.forEach(function (c) {
        var okF = filter === "all" || (" " + c.dataset.cols + " ").indexOf(" " + filter + " ") > -1;
        var okQ = !q || c.dataset.title.indexOf(q) > -1;
        var ok = okF && okQ;
        if (ok) matched++;
        var vis = ok && shown < limit;
        if (vis) shown++;
        c.hidden = !vis;
      });
      if (empty) empty.hidden = matched !== 0;
      if (moreBtn) {
        var wrap = moreBtn.parentNode;
        wrap.hidden = matched <= limit;
        if (moreTxt) moreTxt.textContent = (section.dataset.showing || "Showing [x] of [y]").replace("[x]", Math.min(limit, matched)).replace("[y]", matched);
      }
    }

    pills.forEach(function (p) {
      p.addEventListener("click", function () {
        filter = p.dataset.handle; limit = step;
        pills.forEach(function (x) { x.setAttribute("aria-pressed", x === p ? "true" : "false"); });
        apply();
      });
    });
    if (search) search.addEventListener("input", function () { limit = step; apply(); });
    if (moreBtn) moreBtn.addEventListener("click", function () { limit += step; apply(); });

    $$(".ms-card", section).forEach(function (card) { initCard(card, cartUrl); });
    apply();

    // Deep link from other sections: ms:filter event
    document.addEventListener("ms:filter", function (e) {
      var p = pills.filter(function (x) { return x.dataset.handle === e.detail; })[0];
      if (p) p.click();
      var head = $(".ms-grid-head", section) || section;
      head.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }

  function initCard(card, cartUrl) {
    var dataEl = $("script[type='application/json']", card);
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var options = (data.options || []).map(function (o) { return String(o).toLowerCase(); });
    var cIdx = options.findIndex(function (o) { return COLOR_NAMES.indexOf(o) > -1; });
    var sIdx = options.findIndex(function (o, i) { return i !== cIdx; });
    var flat = $(".ms-card__flat img", card);
    var night = $(".ms-card__night img", card);
    var swWrap = $(".ms-swatches", card);
    var colorLabel = $(".ms-card__color", card);
    var sizes = $(".ms-card__sizes", card);
    var sizesGrid = $(".ms-card__sizes-grid", card);
    var sizesTitle = $(".ms-card__sizes-head span", card);
    var quickBtn = $(".ms-card__quickbtn", card);
    var current = cIdx > -1 && data.colors.length ? data.colors[0].name : null;

    function setColor(name) {
      current = name;
      var c = data.colors.filter(function (x) { return x.name === name; })[0];
      if (c && c.img) { flat.src = c.img; night.src = c.img; flat.alt = data.title + " – " + name; }
      if (colorLabel) colorLabel.textContent = name || "";
      $$(".ms-swatch", swWrap).forEach(function (b) { b.setAttribute("aria-checked", b.dataset.name === name ? "true" : "false"); });
      renderSizes();
    }

    function renderSizes() {
      if (!sizesGrid) return;
      var vs = data.variants.filter(function (v) { return cIdx < 0 || v.o[cIdx] === current; });
      vs.sort(function (a, b) {
        var sa = sIdx > -1 ? a.o[sIdx] : "", sb = sIdx > -1 ? b.o[sIdx] : "";
        return SIZE_ORDER.indexOf(sa) - SIZE_ORDER.indexOf(sb);
      });
      sizesGrid.innerHTML = "";
      vs.forEach(function (v) {
        var b = document.createElement("button");
        b.type = "button";
        b.textContent = sIdx > -1 ? v.o[sIdx] : v.o[0];
        b.disabled = !v.a;
        b.addEventListener("click", function () { add(v, b); });
        sizesGrid.appendChild(b);
      });
      if (sizesTitle) sizesTitle.textContent = (sizesTitle.dataset.label || "Select size") + (current ? " · " + current : "");
    }

    function add(v, btn) {
      btn.disabled = true;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      fetch(root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function () {
          sizes.classList.remove("is-open");
          toast("✓ " + data.title + (current ? " · " + current : "") + " · " + btn.textContent + " added to cart <a href='" + cartUrl + "'>View cart</a>");
          refreshCartBubble();
          document.dispatchEvent(new CustomEvent("cart:refresh"));
        })
        .catch(function () { toast("That size couldn't be added. Open the product page to try again."); })
        .finally(function () { btn.disabled = false; });
    }

    // swatches
    if (swWrap && cIdx > -1 && data.colors.length) {
      var expanded = false;
      var draw = function () {
        swWrap.innerHTML = "";
        var list = expanded ? data.colors : data.colors.slice(0, 5);
        list.forEach(function (c) {
          var b = document.createElement("button");
          b.type = "button"; b.className = "ms-swatch"; b.dataset.name = c.name;
          b.setAttribute("role", "radio"); b.setAttribute("aria-label", c.name); b.title = c.name;
          b.style.background = c.hex || HEX[c.name.toLowerCase()] || "#888";
          b.setAttribute("aria-checked", c.name === current ? "true" : "false");
          b.addEventListener("click", function () { setColor(c.name); });
          swWrap.appendChild(b);
        });
        if (!expanded && data.colors.length > 5) {
          var m = document.createElement("button");
          m.type = "button"; m.className = "ms-swatch-more"; m.textContent = "+" + (data.colors.length - 5);
          m.setAttribute("aria-label", "Show all colours");
          m.addEventListener("click", function () { expanded = true; draw(); });
          swWrap.appendChild(m);
        }
      };
      draw();
      if (colorLabel) colorLabel.textContent = current;
    }
    renderSizes();

    if (quickBtn) quickBtn.addEventListener("click", function (e) { e.preventDefault(); sizes.classList.add("is-open"); var f = $("button:not([disabled])", sizesGrid); if (f) f.focus(); });
    var close = $(".ms-card__sizes-head button", card);
    if (close) close.addEventListener("click", function () { sizes.classList.remove("is-open"); quickBtn && quickBtn.focus(); });
    card.addEventListener("mouseleave", function () { sizes.classList.remove("is-open"); });
  }

  /* ---------------- Spotlight tabs ---------------- */
  function initTabs(section) {
    var tabs = $$("[role='tab']", section);
    tabs.forEach(function (t) {
      t.addEventListener("click", function () {
        tabs.forEach(function (x) {
          var on = x === t;
          x.setAttribute("aria-selected", on ? "true" : "false");
          var panel = document.getElementById(x.getAttribute("aria-controls"));
          if (panel) panel.hidden = !on;
        });
      });
    });
  }

  /* ---------------- Club calculator + dialog ---------------- */
  function initClub(section) {
    var roster = $("[data-roster]", section), fans = $("[data-fans]", section);
    var sum = $("[data-sum]", section), units = $("[data-units]", section), est = $$("[data-est]", section);
    var per = parseFloat(section.dataset.royalty || "3");
    var rPer = parseFloat(section.dataset.rosterRate || "2.2");
    var fShare = parseFloat(section.dataset.fanShare || "0.08");
    var fPer = parseFloat(section.dataset.fanPieces || "1.4");
    var fmt = function (n) { return n.toLocaleString("de-DE"); };
    function pct(el) { el.style.setProperty("--pct", ((el.value - el.min) / (el.max - el.min)) * 100 + "%"); }
    function calc() {
      [roster, fans].forEach(function (el) { pct(el); var o = el.parentNode.querySelector("output"); if (o) o.textContent = fmt(Number(el.value)); });
      var u = Math.round(Number(roster.value) * rPer + Number(fans.value) * fShare * fPer);
      var p = Math.round(u * per);
      sum.textContent = "€" + fmt(p);
      units.textContent = fmt(u);
      est.forEach(function (e) { e.textContent = "€" + fmt(p); if (e.tagName === "INPUT") e.value = "€" + fmt(p) + " / year (" + fmt(u) + " pieces)"; });
    }
    if (roster && fans) { roster.addEventListener("input", calc); fans.addEventListener("input", calc); calc(); }

    var dlg = $("dialog", section), open = $("[data-open-dialog]", section);
    if (dlg && open) {
      open.addEventListener("click", function () { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute("open", ""); });
      $$("[data-close-dialog]", dlg).forEach(function (b) { b.addEventListener("click", function () { dlg.close(); }); });
      dlg.addEventListener("click", function (e) { if (e.target === dlg) dlg.close(); });
      if (dlg.querySelector("[data-posted]") && dlg.showModal) dlg.showModal();
    }
  }

  /* ---------------- Fabric size guide ---------------- */
  function initSizes(section) {
    var btns = $$(".ms-unit button", section);
    btns.forEach(function (b) {
      b.addEventListener("click", function () {
        var u = b.dataset.unit;
        btns.forEach(function (x) { x.setAttribute("aria-pressed", x === b ? "true" : "false"); });
        $$("output[data-cm]", section).forEach(function (o) {
          var c = o.dataset.cm.split("/").map(Number);
          o.textContent = u === "cm" ? c.join(" / ") : c.map(function (v) { return (v / 2.54).toFixed(1); }).join(" / ");
        });
      });
    });
  }

  /* ---------------- Cross-section links ---------------- */
  function initFilterLinks() {
    $$("[data-ms-filter]").forEach(function (a) {
      a.addEventListener("click", function (e) {
        if (!document.querySelector(".ms-grid")) return; // no grid on page: follow the link
        e.preventDefault();
        document.dispatchEvent(new CustomEvent("ms:filter", { detail: a.dataset.msFilter }));
      });
    });
  }

  function init(root) {
    $$("[data-ms-grid]", root).forEach(initGrid);
    $$("[data-ms-tabs]", root).forEach(initTabs);
    $$("[data-ms-club]", root).forEach(initClub);
    $$("[data-ms-sizes]", root).forEach(initSizes);
    initFilterLinks();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { init(document); });
  else init(document);
  // Theme editor: re-init a section after it is re-rendered
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
})();
